
import { defineComponent } from 'vue';
import MainLayout from '@/layout/MainLayout.vue';
import RowComponent from '@/components/stats/RowComponent.vue';
import { usePrivateSellersStore } from '@/store/PrivateSellersStore';
import { useAuthStore } from '@/store/AuthStore';
import { useGalleryStore } from '@/store/GalleriesStore';
import { useArtistsStore } from '@/store/ArtistsStore';
import {
  AnalyticsData,
  DashboardAnalytics,
  Data,
  Artworks,
  UserRecord,
  Analytics,
  LikesAnalytics,
  Image,
} from '@/dataTypes/types';
import TopTenListComponent from '@/components/stats/TopTenListComponent.vue';
import SpinnerLoader from '@/components/loader/SpinnerLoader.vue';

export interface ThisArtist {
  id: number;
  first_name: string;
  last_name: string;
  is_featured: boolean | null;
  region_id: number;
  country_id: number;
  full_name: string;
  artworks: Artworks;
  analytics: Analytics;
  likes_analytics: LikesAnalytics;
  dashboard_analytics: DashboardAnalytics;
  image: Image;
  cv_file: null;
  about: null;
  website: null;
  articles: any[];
  key_collections: any[];
  selected_exhibitions: any[];
}

export default defineComponent({
  name: 'HomeView',
  components: { MainLayout, RowComponent, TopTenListComponent, SpinnerLoader },
  data() {
    const gallery = useGalleryStore();
    const artist = useArtistsStore();
    const auth = useAuthStore();
    const privateSeller = usePrivateSellersStore();
    return {
      gallery,
      auth,
      artist,
      privateSeller,
      userInfo: {} as UserRecord,
      galleryInfo: {} as Data,
      privateSellerInfo: {} as Data,
      galleryAnalytics: {} as DashboardAnalytics,
      artistsAnalytics: [] as AnalyticsData[],
      artworksAnalytics: [] as AnalyticsData[],
      countriesAnalytics: [] as AnalyticsData[],
      artistInfo: {} as ThisArtist,
      artistsCount: 0,
      artworksData: 0,
      artworksDetails: {} as Artworks,
      showsCount: 0,
      isLoading: true,
      type: '',
    };
  },
  computed: {
    isGalleryOrPrivateSeller() {
      return this.type === 'gallery' || this.type === 'private_seller';
    },
  },
  async created() {
    if (this.auth.isLoggedIn) {
      this.userInfo = await this.auth.fetchUserInfo();
      this.type = this.userInfo.role;
      if (this.type === 'gallery') {
        this.galleryInfo = await this.gallery.getInfo();
        this.artistsAnalytics =
          this.galleryInfo.gallery.dashboard_analytics.artists;
        this.artworksAnalytics =
          this.galleryInfo.gallery.dashboard_analytics.artworks;
        this.countriesAnalytics =
          this.galleryInfo.gallery.dashboard_analytics.countries;
        this.artistsCount = this.galleryInfo.gallery.artists;
        this.artworksDetails = this.galleryInfo.gallery.artworks;
        this.showsCount = this.galleryInfo.gallery.shows;
      } else if (this.type === 'private_seller') {
        this.privateSellerInfo = await this.privateSeller.getInfo();
        this.artistsAnalytics = [];
        this.artworksAnalytics = [];
        this.countriesAnalytics = [];
        this.artistsCount = this.privateSellerInfo.private_seller?.artists || 0;
        this.artworksDetails = this.privateSellerInfo.private_seller
          ?.artworks || {
          total: 0,
          live: 0,
          for_sale: 0,
          pending: 0,
        };
      } else if (this.type === 'artist') {
        this.artistInfo = await this.artist.getInfo();
        this.artworksAnalytics = this.artistInfo?.dashboard_analytics?.artworks;
        this.countriesAnalytics =
          this.artistInfo?.dashboard_analytics?.countries;
      }
      this.isLoading = false;
    }
  },
  mounted() {
    const auth = useAuthStore();
    this.type = auth.userInfo.role;
  },
  updated() {
    const auth = useAuthStore();
    this.type = auth.userInfo.role;
  },
  beforeUnmount() {
    const auth = useAuthStore();
    this.type = auth.userInfo.role;
  },
});
